/**
 * Intellicare design system – colors, typography, spacing.
 * Matches design images: dark blue header, white content, consistent fonts.
 */
import { createTheme } from '@mui/material/styles';

export const intellicareColors = {
  primary: '#012676',
  primaryDark: '#011a5c',
  primaryLight: '#1a3a9e',
  background: '#ffffff',
  backgroundGrey: '#f5f5f5',
  border: '#e0e0e0',
  textPrimary: '#212121',
  textSecondary: '#757575',
  statusActive: '#2e7d32',
  statusFollowUp: '#ed6c02',
  statusInactive: '#616161',
  error: '#d32f2f',
  white: '#ffffff',
};

export const theme = createTheme({
  palette: {
    primary: { main: intellicareColors.primary, dark: intellicareColors.primaryDark, light: intellicareColors.primaryLight },
    background: { default: intellicareColors.backgroundGrey, paper: intellicareColors.background },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, fontSize: '1.5rem' },
    h5: { fontWeight: 700, fontSize: '1.25rem' },
    h6: { fontWeight: 600, fontSize: '1.125rem' },
    subtitle1: { fontWeight: 600, fontSize: '0.9375rem' },
    subtitle2: { fontWeight: 500, fontSize: '0.8125rem' },
    body1: { fontSize: '0.875rem' },
    body2: { fontSize: '0.8125rem' },
    caption: { fontSize: '0.75rem' },
  },
  shape: { borderRadius: 4 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
        containedPrimary: { backgroundColor: intellicareColors.primary, '&:hover': { backgroundColor: intellicareColors.primaryDark } },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 500 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
});
